<!-- その他ページ -->
<template>
  <div class="crpg-t-contents-detail">
    <CMS
      contents_type="other_page"
      view_type="detail"
      @catchTitle="setTitle"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      timer: null,
      counter: 0
    };
  },
  computed: {},
  methods: {
    setTitle(obj) {
      this.title = obj;
      this.$meta?.setDocumentTitle(this.title);
    }
  },
};
</script>

<style lang="scss" scoped></style>
